import Toggle from '@scripts/components/Toggle';
import IcrasForm from '@scripts/forms/IcrasForm';
import IcrasHelpers from '@scripts/helpers';

/**
 * Front controller
 */
export default class {
  /**
   * Global icras form
   *
   * @private
   *
   * @type {IcrasForm}
   */
  #form;

  /**
   * Generate and download PDF after click on button
   *
   * @private
   *
   * @param {Event} e Click event
   *
   * @return {void}
   */
  #handlerBtnPdfClick(e) {
    e.preventDefault();
    this.#form.downloadPDF();
  }

  boot() {
    // check the required global variable
    if (!window?.Icras) {
      throw new Error('Icras Front: Icras is not defined');
    }

    this.#form = new IcrasForm();

    // Tooltip
    document.querySelectorAll('.icras-tooltip').forEach((tooltip) => {
      tooltip.addEventListener('click', (e) => {
        e.preventDefault();

        let text = e.currentTarget.querySelector('.icras-tooltip-content');
        if (text) {
          this.#form.openPopin(IcrasHelpers.buildPopinContent(text.innerHTML));
        }
      });
    });

		// Toggle
    this.#form.element
      .querySelectorAll('.icras-toggle-trigger')
      .forEach((elt) => new Toggle(elt));

    // PDF
    document
      .querySelectorAll('.icras-btn-pdf')
      .forEach((btn) =>
        btn.addEventListener('click', (e) => this.#handlerBtnPdfClick(e))
      );

    // Initialize form
    this.#form.initialize();
  }
}
